import { useEffect, useRef } from 'react';

const useOnceWhen = (isReady: boolean, fire: () => void) => {
  const hasFired = useRef(false);

  useEffect(() => {
    if (!isReady || hasFired.current) return;
    hasFired.current = true;
    fire();
  }, [isReady, fire]);
};

export default useOnceWhen;
